import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { key_Scholarships } from "../utils/constants";
import { getScholarships } from "../services/school/scholarship";

export const useGetScholarshipsQuery = (data: PagedRequestType, options: any = null) => {
    return useQuery([key_Scholarships, JSON.stringify(data)], () => getScholarships(data),options? {...options}:{}
);
};
